import React from 'react';

import { LayoutInstance } from '../../config/shared/types/page';
import { ContentArea } from '../ContentArea';
import { ContentAreas, ContentAreaKey } from '../types/contentAreas';
import { LAYOUTS } from './layouts';

type LayoutRendererProps = {
  layoutInstance: LayoutInstance;
};

export const LayoutRenderer = ({ layoutInstance }: LayoutRendererProps) => {
  const LayoutComponent = LAYOUTS[layoutInstance.layout_definition_id];

  const contentAreas = Object.keys(layoutInstance.content_areas).reduce(
    (contentAreasMap, contentAreaName) => {
      contentAreasMap[contentAreaName as ContentAreaKey] = layoutInstance.content_areas[
        contentAreaName
      ].map((contentArea, index) => <ContentArea key={index} contentArea={contentArea} />);

      return contentAreasMap;
    },
    {} as ContentAreas,
  );

  return <LayoutComponent contentAreas={contentAreas} />;
};
